
const brands = [
  { name: 'DNKa', logo: 'https://public.readdy.ai/ai/img_res/094943b71c22f25823fca55c4e6e8ec4.jpg' },
  { name: 'F.O.X', logo: 'https://readdy.ai/api/search-image?query=FOX%20nail%20products%20brand%20logo%20elegant%20typography%20on%20white%20background%20minimalist%20beauty%20brand%20logo%20design%20professional%20nail%20gel%20company%20logo&width=200&height=80&seq=brand-fox&orientation=landscape' },
  { name: 'Luna Moon', logo: 'https://readdy.ai/api/search-image?query=Luna%20Moon%20cosmetics%20brand%20logo%20elegant%20typography%20on%20white%20background%20minimalist%20beauty%20brand%20logo%20design%20professional%20nail%20products%20company%20logo&width=200&height=80&seq=brand-luna&orientation=landscape' },
  { name: 'Touch', logo: 'https://readdy.ai/api/search-image?query=Touch%20beauty%20equipment%20brand%20logo%20elegant%20typography%20on%20white%20background%20minimalist%20brand%20logo%20design%20professional%20nail%20lamp%20company%20logo&width=200&height=80&seq=brand-touch&orientation=landscape' },
  { name: 'Trendy Nails', logo: 'https://readdy.ai/api/search-image?query=Trendy%20Nails%20brand%20logo%20elegant%20typography%20on%20white%20background%20minimalist%20beauty%20brand%20logo%20design%20professional%20nail%20products%20company%20logo&width=200&height=80&seq=brand-trendy&orientation=landscape' },
  { name: 'Nails Of The Day', logo: 'https://readdy.ai/api/search-image?query=Nails%20Of%20The%20Day%20brand%20logo%20elegant%20typography%20on%20white%20background%20minimalist%20beauty%20brand%20logo%20design%20professional%20nail%20care%20company%20logo&width=200&height=80&seq=brand-notd&orientation=landscape' }
];

export default function BrandsSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-serif font-bold text-center text-stone-900 mb-12">
          MARCAS CON LAS QUE TRABAJAMOS
        </h2>
        
        <div className="flex flex-wrap justify-center items-center gap-12">
          {brands.map((brand) => (
            <div key={brand.name} className="grayscale hover:grayscale-0 transition-all cursor-pointer opacity-70 hover:opacity-100">
              <img
                src={brand.logo}
                alt={brand.name}
                className="h-12 object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
